import { fetchConToken } from '../utils/fetch.ts';
import { APP_CONFIG } from '../config/app.ts';

/**
 * Carga un documento desde un coordinador
 * @param {number} girId - ID de la gira
 * @param {string} docTipo - Tipo de documento
 * @param {File} archivo - Archivo a subir
 * @param {string} docDescripcion - Descripción del documento (opcional)
 * @returns {Promise<Object>} Resultado de la operación
 */
export const cargarDocumentoCoordinador = async (
  girId: number,
  docTipo: string,
  archivo: File,
  docDescripcion?: string
) => {
  try {
    const formData = new FormData();
    formData.append('girId', girId.toString());
    formData.append('docTipo', docTipo);
    if (docDescripcion) {
      formData.append('docDescripcion', docDescripcion);
    }
    formData.append('document', archivo);

    const token = localStorage.getItem('token');
    const resp = await fetch(
      `${APP_CONFIG.apiUrl || 'http://localhost:3001'}/giras/cargar-documento-coordinador`,
      {
        method: 'POST',
        headers: {
          'x-token': token
        },
        body: formData
      }
    );

    const body = await resp.json();
    return body;
  } catch (error) {
    console.error('Error al cargar documento:', error);
    return { error: true, msg: 'Error al cargar documento' };
  }
};

/**
 * Obtiene todos los documentos de coordinadores para una gira
 * @param {number} girId - ID de la gira
 * @returns {Promise<Object>} Lista de documentos o error
 */
export const obtenerDocumentosCoordinador = async (girId: number) => {
  try {
    const resp = await fetchConToken(`giras/documentos-coordinador/${girId}`, {}, 'GET');
    const body = await resp.json();
    return body;
  } catch (error) {
    console.error('Error al obtener documentos:', error);
    return { error: true, msg: 'Error al obtener documentos' };
  }
};

/**
 * Actualiza la descripción de un documento
 * @param {number} docId - ID del documento
 * @param {string} docDescripcion - Nueva descripción
 * @returns {Promise<Object>} Resultado de la operación
 */
export const actualizarDocumentoCoordinador = async (
  docId: number,
  docDescripcion: string
) => {
  try {
    const resp = await fetchConToken(
      'giras/actualizar-documento-coordinador',
      { docId, docDescripcion },
      'POST'
    );
    const body = await resp.json();
    return body;
  } catch (error) {
    console.error('Error al actualizar documento:', error);
    return { error: true, msg: 'Error al actualizar documento' };
  }
};

/**
 * Elimina un documento de coordinador
 * @param {number} docId - ID del documento
 * @returns {Promise<Object>} Resultado de la operación
 */
export const eliminarDocumentoCoordinador = async (docId: number) => {
  try {
    const resp = await fetchConToken(
      'giras/eliminar-documento-coordinador',
      { docId },
      'POST'
    );
    const body = await resp.json();
    return body;
  } catch (error) {
    console.error('Error al eliminar documento:', error);
    return { error: true, msg: 'Error al eliminar documento' };
  }
};

/**
 * Descarga un documento de coordinador
 * @param {number} docId - ID del documento
 */
export const descargarDocumentoCoordinador = async (docId: number) => {
  try {
    const token = localStorage.getItem('token');
    const resp = await fetch(
      `${APP_CONFIG.apiUrl || 'http://localhost:3001'}/giras/descargar-documento-coordinador/${docId}`,
      {
        method: 'GET',
        headers: {
          'x-token': token
        }
      }
    );

    if (!resp.ok) {
      throw new Error('Error descargando documento');
    }

    const blob = await resp.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download =
      resp.headers
        .get('content-disposition')
        ?.split('filename=')[1]
        ?.replace(/"/g, '') || 'documento';
    document.body.appendChild(link);
    link.click();
    link.parentNode?.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error al descargar documento:', error);
  }
};
